<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 2H3a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1zm-1 18H4V4h16z"/><path d="M12 19a7 7 0 10-7-7 7 7 0 007 7zm0-13a6 6 0 11-6 6 6 6 0 016-6z"/><circle cx="15" cy="12" r="1"/><circle cx="9" cy="12" r="1"/></svg>